module.exports = __webpack_public_path__ + "static/media/mp4-simple-icon.94b99702.svg";